import funcion from './funcion/funcion'

const login = {
  funcion: funcion
}

export default login;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/login/loginapi.js
// module id = null
// module chunks = 